import { render } from "./DemoSection.vue?vue&type=template&id=6539e045"
import script from "./DemoSection.vue?vue&type=script&lang=js"
export * from "./DemoSection.vue?vue&type=script&lang=js"

import "./DemoSection.vue?vue&type=style&index=0&id=6539e045&lang=less"
script.render = render

export default script